import { createReducer } from '@reduxjs/toolkit'
import { IStateCurrentStation } from './TReducer'
import { Actions_CurrentStation } from './Actions'

const initialState: IStateCurrentStation = {
  isLoading: false,
  data: null,
  responseInfo: null,
}

const ReducerCurrentStation = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_CurrentStation.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_CurrentStation.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_CurrentStation.store.saveCurrentStation, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
})

export default ReducerCurrentStation
